// M004-F0749 (WebUI #191), coded to Spec core-ledger-account-gateway 1.14.0 (ML001-F0268 / F0269): the issued-invoice reads, isolated in this
// one module. Same transport as creditNoteApi.js: Core's Service Link Pass-through (CSLPT),
// POST /api/v1/orgs/:orgId/modules/ledger/messages with the closed envelope { relay_version: 1, type, payload, target_user_id? }.
//
// Operations (Spec InvoiceListRequest / InvoiceGetRequest, bodies forwarded unread to the Ledger):
//   invoice.list  payload { user_id?, month?, number?, limit?, offset? }   -> InvoiceListData { invoices, total, limit, offset, next_offset }
//   invoice.get   payload { invoice_id }                                    -> InvoiceGetData { invoice: InvoiceDetail }
//   invoice.pdf   payload { invoice_id }                                    -> InvoicePdfData { filename, content_type, pdf_base64, pdf_sha256, ... }
// target_user_id: list names a customer only when it filters by one (user_id), exactly as credit_note.list; get and pdf name none.
// All three are reads; none carries an Idempotency-Key. Answers keep the credit-note typed shape: response.data.data = the Ledger's data.
import api from './api';

const messagesPath = (orgId) => `/v1/orgs/${encodeURIComponent(orgId)}/modules/ledger/messages`;
const envelope = (type, payload, targetUserId) => ({
  relay_version: 1, type, payload, ...(targetUserId === undefined ? {} : { target_user_id: targetUserId }),
});
const typedAnswer = (response) => ({
  ...response,
  data: { success: true, data: response?.data?.data?.payload?.data },
});
const customerId = (value) => {
  const id = typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value;
  if (!Number.isSafeInteger(id) || id < 1) throw new Error('A customer filter must be a positive whole number');
  return id;
};

export const invoiceApi = {
  // M004-F0752 (WebUI #195): the member Ledger tab. user_id names the member; NO target_user_id (lead ruling 2026-10-13).
  listForMember: async (orgId, userId, params = {}) => typedAnswer(
    await api.post(messagesPath(orgId), envelope('invoice.list', { ...params, user_id: customerId(userId) })),
  ),
  list: async (orgId, params = {}) => {
    const payload = { ...params };
    if (payload.user_id !== undefined) payload.user_id = customerId(payload.user_id);
    return typedAnswer(await api.post(messagesPath(orgId), envelope('invoice.list', payload, payload.user_id)));
  },
  get: async (orgId, invoiceId) => typedAnswer(await api.post(messagesPath(orgId), envelope('invoice.get', { invoice_id: invoiceId }))),
  pdf: async (orgId, invoiceId) => typedAnswer(await api.post(messagesPath(orgId), envelope('invoice.pdf', { invoice_id: invoiceId }))),
};
